import { numberMoney } from 'Data/format.js'

export function getAmount(item) {
  return numberMoney(item.entries.reduce((acc, entry) => acc + entry.amount, 0))
}

export function getDescription(item) {
  return item.entries
    .map(entry => `${getChargeName(entry)} (${numberMoney(entry.amount)})`)
    .join(' + ')
}

function getChargeName(transaction) {
  switch (transaction.dtype) {
    case 'LateFeeCharge':
      return 'Late Fee'
    case 'MiscFeeCharge':
      return transaction.misc_fee_charge.name || 'Miscellaneous Fee'
    case 'RetailFeeCharge':
      return transaction.retail_fee.retail_item.name
    case 'TxFeeCharge':
      return 'Treatment Fee'
    default:
      return 'Miscellaneous Fee'
  }
}
